export default __webpack_public_path__ + "static/media/break.789137fc.svg";